var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-select',{attrs:{"autocomplete":"","disabled":_vm.disabled || _vm.readonly},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}},_vm._l((_vm.disasterList),function(disaster){return _c('vs-select-item',{key:disaster,attrs:{"value":disaster,"text":disaster}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }